import React, { useEffect, useRef, useState } from 'react'

export default function Map({ options, onMount, className, onMountProps }) {
    const ref = useRef()
    const [map, setMap] = useState()

    useEffect(() => {
        const onLoad = () => {
            var map = new window.google.maps.Map(ref.current, options);
            console.log(options);
            setMap(map);
            
            /*setMap(new window.google.maps.Map(ref.current, {
                center: { lat: 51.408632, lng: -0.219922 },
                zoom: 13,
            })
            );*/
            var cityCircle = new window.google.maps.Circle({
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                map: map,
                //center: { lat: 51.408632, lng: -0.219922 },
                center: options.center,
                radius: parseFloat(options.range)*1609,
              });
        }
        if (!window.google) {
            const script = document.createElement(`script`)
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBd1oXopWDgSa-gsvIhhqKMOZQbkaAapjI';
            document.head.append(script)
            script.addEventListener(`load`, onLoad)
            return () => script.removeEventListener(`load`, onLoad)
        } else onLoad()
    }, [options])

    if (map && typeof onMount === `function`) onMount(map, onMountProps)

    return (
        <div
            style={{ height: `60vh`, margin: `1em 0`, borderRadius: `0.5em` }}
            {...{ ref, className }}
        />
    )
}

Map.defaultProps = {
    options: {
        center: { lat: 48, lng: 8 },
        zoom: 5,
    },
}